/* eslint-disable no-unused-vars */
import { createApi } from '@reduxjs/toolkit/dist/query/react';
import { axiosBaseQuery } from '../axios/index';

export const currentCampaignObjToFormatData = (currentCampaignObj) => {
  const formdata = new FormData();
  let newData = structuredClone(currentCampaignObj);
  if (!currentCampaignObj.bid) {
    newData.bid = 0;
  }
  // server model has a non-nullable double Budget; an empty budget field ("") fails deserialization
  if (!currentCampaignObj.budget) {
    newData.budget = 0;
  }
  formdata.append('currentCampaignObj', JSON.stringify(newData));
  return formdata;
};

export const manageCampaignsAPI = createApi({
  reducerPath: 'CampaignsAPI',
  baseQuery: axiosBaseQuery({ baseUrl: '/api/Campaign' }),
  tagTypes: [
    'Campaign/GetCampaignData',
    'Campaign/GetCustomAudiencesList',
    'Campaign/GetMonthlyBudgetApps',
    // 'Campaign/GetGraphDataMergedPeriods',
    'Campaign/GetCampaigns',
    'Campaign/GetCampaignEventsByDates',
    'Campaign/GetCampaignAdvancedSettings',
  ],
  endpoints: (build) => ({
    getCampaigns: build.query({
      query: (date) => ({
        method: 'POST',
        url: `/GetCampaigns?from=${date.from}&to=${date.to}`,
      }),
    }),
    columnsHideSave: build.mutation({
      query: (data) => ({
        url: `/columnsHideSave`,
        method: 'POST',
        data,
      }),
      //invalidatesTags: ['Campaign/GetCampaigns'],
    }),
    getCampaignsByDate: build.query({
      query: (data) => ({
        url: `/GetCampaigns`,
        method: 'POST',
        data: data,
      }),
      //keepUnusedDataFor: 0,
      //providesTags: ['Campaign/GetCampaigns'],
      transformResponse: (response) => {
        const { campaignsData, selectedCols, cmEvents } = response;
        const { events, eventsCohort } = createEvents(cmEvents);
        const selectedColsArray =
          selectedCols && selectedCols.trim()
            ? JSON.parse(selectedCols)
                .cols.filter((field) => field && field.colName && field.isSelected)
                .sort((a, b) => a.selectedOrder - b.selectedOrder)
                .map((field) => field.colName.toLowerCase())
            : [];

        const newCampaignsData = campaignsData.map((camp) => {
          camp.event_name_arr.forEach((eventName, index) => {
            const eventId = camp.event_id_arr[index];
            const eventCount = camp.eventCountArr[index];
            const eventCountCohort = camp.eventCountArrCohort[index];
            if (eventId != null && eventCount != null && eventCountCohort != null) {
              const eventFieldName = createFieldName(eventName, eventId, eventPrefix);
              const eventCohortFieldName = createFieldName(eventName, eventId, eventsCohortPrefix);
              camp[eventFieldName] = eventCount;
              camp[eventCohortFieldName] = eventCountCohort;
            }
          });
          const avg_cpi =
            (camp?.installs || 0) === 0 ? 0 : (camp?.cost || 0) / (camp?.installs || 1);

          const ecpm = camp.eCPM ?? 0;
          return { ...camp, avg_cpi, ecpm };
        });
        return {
          ...response,
          campaignsData: newCampaignsData,
          selectedColsArray,
          events,
          eventsCohort,
        };
      },
    }),
    GetGetGraphData: build.query({
      query: (data) => ({
        url: `/GetGraphData`,
        method: 'POST',
        data: data,
      }),
      // keepUnusedDataFor: 0,
    }),
    // GetGraphDataMergedPeriods: build.query({
    //   query: (data) => ({
    //     url: `/GetGraphDataMergedPeriods`,
    //     method: 'POST',
    //     data: data,
    //   }),
    // }),
    GetCampaignEventsByDates: build.query({
      query: (data) => ({
        url: `/GetCampaignEventsByDates`,
        method: 'POST',
        data: data,
      }),
      providesTags: ['Campaign/GetCampaignEventsByDates'],
    }),
    getCampaignDataById: build.query({
      query: (id) => ({
        url: `/LoadCampaignData?id=${id}`,
        method: 'GET',
      }),
      keepUnusedDataFor: 0, //not cached
      providesTags: ['Campaign/GetCampaignData'],
    }),
    getCampaignData_newEmpty: build.query({
      query: () => ({
        url: `/LoadCampaignData`,
      }),
    }),
    getCreativesTracking: build.query({
      query: (data) => ({
        params: {
          creativesCampaignId: `${data.creativesCampaignId}`,
        },
        url: '/GetCreativesTracking',
        method: 'GET',
      }),
    }),
    getSearchAppsNew: build.query({
      query: ({ cm_id, term }) => ({
        url: '/GetSearchAppsNew',
        params: {
          cm_id,
          term,
          page_no: 1,
          page_size: 500,
        },
      }),
    }),
    getCustomAudiencesList: build.query({
      query: () => ({
        url: '/GetCustomAudiencesList',
      }),
      providesTags: ['Campaign/GetCustomAudiencesList'],
    }),
    saveCustomeAudience: build.mutation({
      query: (data) => ({
        url: '/SaveCustAudFile',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Campaign/GetCustomAudiencesList'],
    }),
    saveCampaignData: build.mutation({
      query: (data) => ({
        url: '/SaveCampaignData',
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Campaign/GetCampaigns', 'Campaign/GetCampaignData'],
    }),
    getFactorBid: build.query({
      query: ({ show_app_name, ...data }) => {
        const formatData = currentCampaignObjToFormatData(data);
        return {
          url: '/CheckFactorBid',
          method: 'POST',
          data: formatData,
        };
      },
      //keepUnusedDataFor: 0, //not cached
      transformResponse: (response, meta, { show_app_name }) => {
        const errMsg = getErrorMsg({ ...response, show_app_name });
        if (!response?.minBidAlowed && typeof response === 'number') {
          return { minBidAlowed: response, errMsg };
        }
        return { ...response, errMsg };
      },
    }),
    GetAppsBudgetCounter: build.query({
      query: (data) => ({
        url: '/GetAppsBudgetCounter',
        data,
        method: 'POST',
      }),
    }),
    // saveMonthlyBudgetApps: build.mutation({
    //   query: (data) => ({
    //     url: '/SaveMonthlyBudgetApps',
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //     },
    //     data,
    //   }),
    //   invalidatesTags: ['Campaign/GetMonthlyBudgetApps'],
    // }),
    // getMonthlyBudgetApps: build.query({
    //   query: (data) => ({
    //     url: '/GetMonthlyBudgetApps',
    //     data,
    //     method: 'POST',
    //   }),
    //   providesTags: ['Campaign/GetMonthlyBudgetApps'],
    //   // transformResponse: (response) => {
    //   //   return response.map((item) => {
    //   //     return {
    //   //       ...item,
    //   //       countries: Math.random() < 0.5 ? 'US, IN, RU, AA, AO' : 'CD',
    //   //       isOpenBudget: Math.random() < 0.1 ? true : false,
    //   //       isAgency: Math.random() < 0.1 ? true : false,
    //   //       ids: [123456, 123456, 123456],
    //   //       countriesBudgetItems: [],
    //   //     };
    //   //   });
    //   // },
    // }),
    getCustomAudiencesForManagement: build.query({
      query: () => ({
        url: '/GetCustomAudiencesForManagement',
      }),
      //providesTags: ['Campaign/GetCustomAudiencesForManagement'],
      // transformResponse: (response) => {
      //   return response.splice(0, 5);
      // },
    }),
    getCampaignAdvancedSettings: build.query({
      query: (cm_id) => ({
        url: `/GetCampaignAdvancedSettings?cm_id=${cm_id}`,
      }),
      transformResponse: (response) => {
        const res = {
          excluded_apps: response.excluded_apps.map((data) => ({ ...data, selected: true })),
          excluded_publishers: response.excluded_publishers.map((data) => ({
            ...data,
            selected: true,
          })),
          typeList: response.typeList,
        };
        return res;
      },
      providesTags: ['Campaign/GetCampaignAdvancedSettings'],
    }),
    saveCampaignAdvancedSettings: build.mutation({
      query: ({ cm_id, data }) => ({
        url: `/SaveCampaignAdvancedSettings?cm_id=${cm_id}`,
        method: 'POST',
        data,
      }),
      invalidatesTags: ['Campaign/GetCampaignAdvancedSettings'],
    }),
    SaveCampaignEvent: build.mutation({
      query: (data) => ({
        url: '/SaveCampaignEvent',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      }),
      invalidatesTags: ['Campaign/GetCampaignEventsByDates'],
    }),
    UpdateCampaignName1: build.mutation({
      query: (data) => ({
        url: '/UpdateCampaignName',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        data,
      }),
    }),
    GetBannerCtaList: build.query({
      query: () => ({
        method: 'POST',
        url: '/GetBannerCtaList',
      }),
    }),
  }),
});

function createEvents(eventsList) {
  const { events, eventsCohort } = eventsList.reduce(
    (acc, event, index) => {
      acc.events.push(createEventTemplate(event, eventPrefix, index));
      acc.eventsCohort.push(createEventTemplate(event, eventsCohortPrefix, index));
      return acc;
    },
    { events: [], eventsCohort: [] },
  );
  return { events, eventsCohort };
}

function createEventTemplate(event, prefix, index) {
  return {
    cellClass: `${prefix}_content_${index}`,
    headerClass: `${prefix}_header`,
    headerName: event.eventName,
    colId: createFieldName(event.eventName, event.eventId, prefix),
    field: createFieldName(event.eventName, event.eventId, prefix),
    filter: false,
    suppressMovable: true,
    resizable: false,
    width: 124,
    minWidth: 124,
    maxWidth: 124,
    hide: !event.isSelected,
  };
}

function createFieldName(eventName, eventId, prefix) {
  const formatedName = eventName.replaceAll('.', '_!_');
  return `${prefix}_${formatedName}_${eventId}`;
}

const eventPrefix = 'events';
const eventsCohortPrefix = 'eventsCohort';

function getErrorMsg({
  directMinCpi_country_code,
  directMinCpi_pba_name,
  directMinCpi_pba_number,
  show_app_name,
}) {
  const errMsgCommonPart = 'The minimum required bid is not met for direct buy';
  const countryCode = directMinCpi_country_code;
  const appName =
    directMinCpi_pba_name &&
    directMinCpi_pba_number &&
    `${(show_app_name ? directMinCpi_pba_name : directMinCpi_pba_number) ?? ''}${
      show_app_name ? ` (${directMinCpi_pba_number})` : ''
    }`;

  if (appName && !countryCode) {
    return `${errMsgCommonPart} application: ${appName}. Either increase the bid or remove the application targeting.`;
  }
  if (countryCode && !appName) {
    return `${errMsgCommonPart} country: ${countryCode}. Either increase the bid or remove the country targeting.`;
  }
  if (countryCode && appName) {
    return `${errMsgCommonPart} application: ${appName} and country: ${countryCode}. Either increase the bid or remove the application/country targeting.`;
  }

  return '';
}
